import { render, staticRenderFns } from "./examRoomHr.vue?vue&type=template&id=4d85bfd1&scoped=true"
import script from "./examRoomHr.vue?vue&type=script&lang=ts"
export * from "./examRoomHr.vue?vue&type=script&lang=ts"
import style0 from "./examRoomHr.vue?vue&type=style&index=0&id=4d85bfd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85bfd1",
  null
  
)

export default component.exports